/**
 * corral, the dev HTTPS proxy, serves a production host `<sub>.<zone>` as
 * `<sub>.<branch>.<dashed-zone>.diw.dev`: the registrable zone's dots become
 * hyphens (one DNS label), and `<branch>` is the git branch the dev stack runs
 * on. An app origin built from the production zone therefore has to be rebuilt
 * from the request's own corral host to resolve in dev. Routes are declared in
 * scripts/dev-routes.ts.
 */
const CORRAL_BASE = "diw.dev";

/**
 * `zone` as corral serves it alongside `requestHost`, or `zone` itself when
 * `requestHost` isn't a corral host (production, or a direct localhost hit).
 */
export function corralZone(zone: string, requestHost: string): string {
  const hostname = requestHost.split(":")[0]?.toLowerCase() ?? "";
  if (!hostname.endsWith(`.${CORRAL_BASE}`)) return zone;
  // The branch is the label just before `<dashed-zone>.diw.dev`.
  const branch = hostname.split(".").at(-4);
  if (!branch) return zone;
  return `${branch}.${zone.toLowerCase().replace(/\./g, "-")}.${CORRAL_BASE}`;
}
